<template>
  <nav>
    <AlertMessages
      v-if="alertValue"  
      :alert-type="alertType" 
      :alert-msg="alertMsg"
      @reset="alertValue = false"
    />
    <v-menu
      ref="menuRef"
      style="z-index: 99"
      offset-y
      top
    >
      <template v-slot:activator="{ on, attrs }">
        <v-fab-transition>
          <v-btn
            data-testid="create-button-in-activiity"
            elevation="2"
            fixed
            left
            fab
            bottom
            large 
            v-bind="attrs"
            style="z-index: 99"
            color="accent"
            v-on="on"
            class="create-activity-item-button"
          >
            <v-icon large>
              mdi-text-box-plus-outline
            </v-icon>
          </v-btn>
        </v-fab-transition>
      </template>
      <v-list data-testid="menu-list">
        <v-list-item
          data-testid="create-activity-section-button"
          router 
          @click.stop="
            dialogVisible=true, 
            confirmationDialogTitle=$t('confirmationDialogTitleCreateActivitySection'), 
            confirmationDialogText=$t(''),
            confirmationDialogInputPlaceholder=$t('confirmationDialogInputPlaceholderCreateActivitySection'), 
            confirmationDialogSubmitBtn=$t('create')
            confirmationDialogCancelBtn=$t('back')
            entityType='section'"

        >
          <v-list-item-title> {{ $t('createSection') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          data-testid="create-activity-page-button"
          router 
          @click.stop="
            dialogVisible=true, 
            confirmationDialogTitle=$t('confirmationDialogTitleCreateActivityPage'), 
            confirmationDialogText=$t(''),
            confirmationDialogInputPlaceholder=$t('confirmationDialogInputPlaceholderCreateActivityPage'), 
            confirmationDialogSubmitBtn=$t('create')
            confirmationDialogCancelBtn=$t('back')
            entityType='page'"
        >
          <v-list-item-title> {{ $t('createPage') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          data-testid="create-activity-checklist-button"
          router 
          @click.stop="
            dialogVisible=true, 
            confirmationDialogTitle=$t('confirmationDialogTitleCreateActivityChecklist'), 
            confirmationDialogText=$t(''),
            confirmationDialogInputPlaceholder=$t('confirmationDialogInputPlaceholderCreateActivityChecklist'), 
            confirmationDialogSubmitBtn=$t('create')
            confirmationDialogCancelBtn=$t('back')
            entityType='checklist'"
        >
          <v-list-item-title>
            {{ $t('createChecklist') }} 
          </v-list-item-title>
        </v-list-item>
        <v-list-item
          data-testid="create-activity-quiz-button"
          router 
          @click.stop="
            dialogVisible=true, 
            confirmationDialogTitle=$t('confirmationDialogTitleCreateActivityQuiz'), 
            confirmationDialogText=$t(''),
            confirmationDialogInputPlaceholder=$t('confirmationDialogInputPlaceholderCreateActivityQuiz'), 
            confirmationDialogSubmitBtn=$t('create')
            confirmationDialogCancelBtn=$t('back')
            entityType='quiz'"
        >
          <v-list-item-title> {{ $t('createQuiz') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
          v-if="productPlan.attributes && productPlan.attributes.scorm_packages == 1"
          data-testid="add-activity-scorm-button"
          router 
          @click.stop="
            dialogVisible=true, 
            confirmationDialogTitle=$t('confirmationDialogTitleAddActivityScorm'), 
            confirmationDialogText=$t(''),
            confirmationDialogInputPlaceholder=$t('confirmationDialogInputPlaceholderAddActivityScorm'), 
            confirmationDialogSubmitBtn=$t('add')
            confirmationDialogCancelBtn=$t('back')
            entityType='scorm'"
        >
          <v-list-item-title> {{ $t('addScorm') }}</v-list-item-title>
        </v-list-item>
        <v-list-item
            data-testid="create-activity-survey-button"
            router 
            @click.stop="
            dialogVisibleSurvey=true, 
            confirmationDialogTitle=$t('confirmationDialogTitleCreateActivitySurvey'), 
            confirmationDialogText=$t(''),
            confirmationDialogInputPlaceholder=$t('confirmationDialogInputPlaceholderCreateActivitySurvey'), 
            confirmationDialogSubmitBtn=$t('create')
            confirmationDialogCancelBtn=$t('back')
            entityType='survey'"
          style="max-width: fit-content"
        >
          <v-list-item-title> {{ $t('createSurvey') }}</v-list-item-title>
          
        </v-list-item>
      </v-list>
    </v-menu>
    <ConfirmationDialogWithInputField 
      v-if="dialogVisible"
      :visible="dialogVisible" 
      :cd-title="confirmationDialogTitle" 
      :cd-text="confirmationDialogText" 
      :cd-input-placeholder="confirmationDialogInputPlaceholder" 
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn" 
      data-testid="form-dialog" 
      @close="dialogVisible=false"
      @proceedSubmit="createEntity"
    />
    <ConfirmationDialogWithInputFieldAndCheckbox
      v-if="dialogVisibleSurvey"
      :visible="dialogVisibleSurvey" 
      :cd-title="confirmationDialogTitle" 
      :cd-input-placeholder="confirmationDialogInputPlaceholder" 
      :cd-submit-btn="confirmationDialogSubmitBtn"
      :cd-cancel-btn="confirmationDialogCancelBtn"
      :checkbox-label="$t('surveyAnonymousCheckboxLabel')"
      :checkbox-title="$t('surveyAnonymousCheckboxTitle')" 
      data-testid="form-dialog" 
      @close="dialogVisibleSurvey=false"
      @proceedSubmit="createActivitySurvey"
    />   
   
  </nav>
</template>

<script>
import ConfirmationDialogWithInputField from './ConfirmationDialogWithInputField'
import ConfirmationDialogWithInputFieldAndCheckbox from './ConfirmationDialogWithInputFieldAndCheckbox'
import { getActivityPages, createActivityPage, createActivitySection, createActivityQuiz, addActivityScorm, createActivityChecklist, createActivitySurvey} from '../api/activityApi'
import i18n from '../plugins/i18n'
import {eventBus} from '../eventbus'
import AlertMessages  from './AlertMessages'

export default {
    components: {
        ConfirmationDialogWithInputField,
        ConfirmationDialogWithInputFieldAndCheckbox,
        AlertMessages
    },
    props: {
    },
    data(){
        return{
            isAuth: window.$cookies.get("token")? true: false,
            title: '',
            activityId: this.$route.params.id,
            alertMsg: '',
            alertValue:false,
            alertType: '',
            activity_pages: [],
            confirmationDialogTitle: '',
            confirmationDialogText: '',
            confirmationDialogCancelBtn: '',
            confirmationDialogSubmitBtn: '',
            confirmationDialogInputPlaceholder: '',
            dialogVisible: false,
            entityType: 'page',
            dialogVisibleSurvey: false
        }
    },
    computed: {
        productPlan() {
            return this.$store.state.productPlan;
        },
    },
    methods: {
        createEntity(title){
            if(this.entityType == 'section'){
                this.createActivitySection(title)
            }else if(this.entityType == 'page'){
                this.createActivityPage(title)
            }else if(this.entityType == 'checklist'){
                this.createActivityChecklist(title)
            }else if(this.entityType == 'quiz'){
                this.createActivityQuiz(title)
            }else{
                this.addActivityScorm(title)
            }
            
        },
    
        async createActivityPage(title){
            this.dialogVisible = false
            try {
                this.loadingData = true
                let data = {
                    data: {
                        type: "activity-pages", 
                        attributes: {
                            title: title.trim()
                        },
                        relationships: {
                            activity: {
                                data: {
                                    type: "activities",
                                    id: this.activityId
                                }
                            }
                        }
                    }
                };
                var response = await createActivityPage(data);
                if(response){
                    if(response.status == 201) {
                        const response_pages = await getActivityPages(this.activityId)
                        this.activity_pages = response_pages.data.data
                        window.$cookies.set("activity-feed-state-" + this.activityId, true, 0, null, process.env.VUE_APP_DOMAIN)
                        eventBus.$emit('changeNavigationInActivity', this.activity_pages)
                        this.alertMsg = i18n.t('createActivityPageSuccess');
                        this.alertType = 'success'
                        this.alertValue = true
                        this.$router.push({name: 'ViewActivityPage', params: {id: this.activityId, pageId: response.data.data.id, successfullyCreatedActivityPage: true}})
                       
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    if (e.response.status == 422 ){
                        this.alertMsg =  i18n.t('serverError')
                    } else if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    }else {
                        this.alertMsg =  i18n.t('serverError')
                    }
                }else{
                    this.alertType = 'error'
                    this.alertValue = true
                    this.alertMsg =  i18n.t('serverError')       
                }
            }
            this.loadingData = false
        },
        async createActivitySection(title){
            this.dialogVisible = false
            try {
                this.loadingData = true
                let data = {
                    data: {
                        type: "sections", 
                        attributes: {
                            title: title.trim()
                        },
                        relationships: {
                            activity: {
                                data: {
                                    type: "activities",
                                    id: this.activityId
                                }
                            }
                        }
                    }
                };
                var response = await createActivitySection(data);
                if(response){
                    if(response.status == 201) {
                        const response_pages = await getActivityPages(this.activityId)
                        this.activity_pages = response_pages.data.data
                        window.$cookies.set("activity-feed-state-" + this.activityId, true, 0, null, process.env.VUE_APP_DOMAIN)
                        eventBus.$emit('changeNavigationInActivity', this.activity_pages)
                        this.alertMsg = i18n.t('createActivitySectionSuccess');
                        this.alertType = 'success'
                        this.alertValue = true
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertType = 'error'
                    this.alertValue = true
                    if (e.response.status == 422 ){
                        this.alertMsg =  i18n.t('serverError')
                    } else if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertMsg =  i18n.t('serverError')
                    }
                }else{
                    this.alertType = 'error'
                    this.alertValue = true
                    this.alertMsg =  i18n.t('serverError')       
                }
            }
            this.loadingData = false
        },
        async createActivityQuiz(title){
            this.dialogVisible = false
            try {
                this.loadingData = true
                let data = {
                    data: {
                        type: "quizzes", 
                        attributes: {
                            title: title.trim()
                        },
                        relationships: {
                            activity: {
                                data: {
                                    type: "activities",
                                    id: this.activityId
                                }
                            }
                        }
                    }
                };
                var response = await createActivityQuiz(data);
                if(response){
                    if(response.status == 201) {
                        const response_pages = await getActivityPages(this.activityId)
                        this.activity_pages = response_pages.data.data
                        window.$cookies.set("activity-feed-state-" + this.activityId, true, 0, null, process.env.VUE_APP_DOMAIN)
                        eventBus.$emit('changeNavigationInActivity', this.activity_pages)
                        this.alertMsg = i18n.t('createActivityQuizSuccess');
                        this.alertType = 'success'
                        this.alertValue = true
                        this.$router.push({name: 'ViewActivityQuiz', params: {id: this.activityId, quizId: response.data.data.id, successfullyCreatedActivityQuiz: true}})
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    if (e.response.status == 422 ){
                        this.alertMsg =  i18n.t('serverError')
                    } else if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertMsg =  i18n.t('serverError')
                    }
                }else{
                    this.alertType = 'error'
                    this.alertValue = true
                    this.alertMsg =  i18n.t('serverError')       
                }
            }
            this.loadingData = false
        },
        async addActivityScorm(title){
            this.dialogVisible = false
            try {
                this.loadingData = true
                let data = {
                    data: {
                        type: "scorms", 
                        attributes: {
                            title: title.trim(),
                            published: false
                        },
                        relationships: {
                            activity: {
                                data: {
                                    type: "activities",
                                    id: this.activityId
                                }
                            }
                        }
                    }
                };
                var response = await addActivityScorm(data);
                if(response){
                    if(response.status == 201) {
                        const response_pages = await getActivityPages(this.activityId)
                        this.activity_pages = response_pages.data.data
                        window.$cookies.set("activity-feed-state-" + this.activityId, true, 0, null, process.env.VUE_APP_DOMAIN)
                        eventBus.$emit('changeNavigationInActivity', this.activity_pages)
                        this.alertMsg = i18n.t('createActivityScormSuccess');
                        this.alertType = 'success'
                        this.alertValue = true
                        this.$router.push({name: 'ViewActivityScorm', params: {id: this.activityId, scormId: response.data.data.id, successfullyAddedActivityScorm: true}})
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    if (e.response.status == 422 ){
                        this.alertMsg =  i18n.t('serverError')
                    } else if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    } else {
                        this.alertMsg =  i18n.t('serverError')
                    }
                }else{
                    this.alertType = 'error'
                    this.alertValue = true
                    this.alertMsg =  i18n.t('serverError')       
                }
            }
            this.loadingData = false
        },
        async createActivityChecklist(title){
            this.dialogVisible = false
            try {
                this.loadingData = true
                let data = {
                    data: {
                        type: "checklists", 
                        attributes: {
                            title: title.trim()
                        },
                        relationships: {
                            activity: {
                                data: {
                                    type: "activities",
                                    id: this.activityId
                                }
                            }
                        }
                    }
                };
                var response = await createActivityChecklist(data);
                if(response){
                    if(response.status == 201) {
                        const response_pages = await getActivityPages(this.activityId)
                        this.activity_pages = response_pages.data.data
                        window.$cookies.set("activity-feed-state-" + this.activityId, true, 0, null, process.env.VUE_APP_DOMAIN)
                        eventBus.$emit('changeNavigationInActivity', this.activity_pages)
                        this.alertMsg = i18n.t('createActivityChecklistSuccess');
                        this.alertType = 'success'
                        this.alertValue = true
                        this.$router.push({name: 'ViewActivityChecklist', params: {id: this.activityId, checklistId: response.data.data.id, successfullyCreatedActivityChecklist: true}})
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    if (e.response.status == 422 ){
                        this.alertMsg =  i18n.t('serverError')
                    } else if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    }else {
                        this.alertMsg =  i18n.t('serverError')
                    }
                }else{
                    this.alertType = 'error'
                    this.alertValue = true
                    this.alertMsg =  i18n.t('serverError')       
                }
            }
            this.loadingData = false
        },

        async createActivitySurvey(title, checked){
            this.dialogVisibleSurvey = false
            try {
                this.loadingData = true
                let data = {
                    data: {
                        type: "surveys", 
                        attributes: {
                            title: title.trim(),
                            published: false,
                            is_anonymous: checked
                        },
                        relationships: {
                            activity: {
                                data: {
                                    type: "activities",
                                    id: this.activityId
                                }
                            }
                        }
                    }
                };
                var response = await createActivitySurvey(data);
                if(response){
                    if(response.status == 201) {
                        const response_pages = await getActivityPages(this.activityId)
                        this.activity_pages = response_pages.data.data
                        window.$cookies.set("activity-feed-state-" + this.activityId, true, 0, null, process.env.VUE_APP_DOMAIN)
                        eventBus.$emit('changeNavigationInActivity', this.activity_pages)
                        this.alertMsg = i18n.t('createActivitySurveySuccess');
                        this.alertType = 'success'
                        this.alertValue = true
                        this.$router.push({name: 'ViewActivitySurvey', params: {id: this.activityId, surveyId: response.data.data.id, successfullyCreatedActivitySurvey: true}})
                    }
                }
            } catch (e) {
                if(e.response){
                    this.alertValue = true
                    this.alertType = 'error'
                    if (e.response.status == 422 ){
                        this.alertMsg =  i18n.t('serverError')
                    } else if (e.response.status == 403){
                        this.$router.push({name: 'PageAccessDenied'})
                    }else {
                        this.alertMsg =  i18n.t('serverError')
                    }
                }else{
                    this.alertType = 'error'
                    this.alertValue = true
                    this.alertMsg =  i18n.t('serverError')       
                }
            }
            this.loadingData = false
        }
    }
}
</script>